/**
 * Adresy obrázkov Dune. Art servíruje náš server z `uploads/dune/`
 * (`scripts/fetch-dune-art.mjs`) — klient nikdy nesiaha na cudzí server.
 * Kus karty má ID `definícia#n`; tretí Cheap Hero má vlastný obrázok (hrdinka).
 */

const BASE = '/api/dune/art';
/** Verzia artu — zvýš, keď sa súbory prerobia (server ich cachuje týždeň). */
const V = '?v=2';

export function cardArt(card: string): string {
  const [id, n] = card.split('#');
  return `${BASE}/treachery/${id === 'cheap-hero' && n === '3' ? 'cheap-heroine' : id}${V}`;
}

export const leaderArt = (leader: string) => `${BASE}/leader/${leader}${V}`;
export const traitorArt = (leader: string) => `${BASE}/traitor/${leader}${V}`;
export const spiceArt = (card: string) => `${BASE}/spice/${card.startsWith('shai-hulud') ? 'shai-hulud' : card}${V}`;
export const backArt = (kind: 'treachery' | 'traitor' | 'spice') => `${BASE}/back/${kind}${V}`;

/** Fonty design systému Dune (Space Mono, IBM Plex Serif) — len keď je modul Dune načítaný. */
export function loadDuneFonts(): void {
  if (document.getElementById('dune-fonts')) return;
  const link = document.createElement('link');
  link.id = 'dune-fonts';
  link.rel = 'stylesheet';
  link.href = '/fonts/dune/fonts.css';
  document.head.append(link);
}
